export default {
  title: 'shipping method Form',
  detail: 'Create or update shipping method',
  nameFa : 'name fa',
  nameEn : 'name en',
  shippingCost:'shipping cost',
  status: 'status',
  statusActive: 'active',
  statusInActive: 'inactive',
  back : 'back',
  success : 'success',
  error : 'error',
  save : 'save',
  loading : 'loading',
  saving : 'saving ...',
  placeholderNameFa:'Enter Name fa',
  placeholderNameEn:'Enter Name en',
  placeholderShippingCost:'Enter shipping cost '





}
